import $ from "jquery";
window.jQuery = $;
import gsap from "gsap";

let sortBy = "year";

$("#expertise-filter li").on("click", function () {
  let text = $(this).text();

  $(".card.profile").each(function () {
    let elem = $(this)[0];
    $(this).removeClass("matches-filter");
    gsap.to(elem, { autoAlpha: 0, y: "3rem", duration: 0.3 });
    gsap.to(elem, { display: "none", duration: 0, delay: 0.3 });
  });

  if ($(this).parents(".filter-wrap").find(".label span").text() === text) {
    $(this)
      .parents(".filter-wrap")
      .find(".label span")
      .text("Filter by Expertise");
    $(".people section.matches-category").show();
    $(".card.profile").each(function () {
      $(this).addClass("matches-filter");
      if ($(this).hasClass("matches-search")) {
        let elem = $(this)[0];
        gsap.to(elem, { display: "block", duration: 0, delay: 0.3 });
        gsap.to(elem, {
          autoAlpha: 1,
          y: "0",
          duration: 0.3,
          stagger: 0.05,
          delay: 0.3,
        });
      }
    });
  } else {
    let delay = 0.3;

    $(this).parents(".filter-wrap").find(".label span").text(text);

    let filter = $(this).data("filter");

    $(".people section.matches-category").each(function () {
      let resultsCount = 0;
      console.log(resultsCount);
      $(this)
        .find(".profile")
        .each(function () {
          let elem = $(this)[0];
          let expertise = $(this).data("expertise");
          let expertiseArray = expertise.split(",");

          if (expertiseArray.includes(filter)) {
            $(this).addClass("matches-filter");
            if ($(this).hasClass("matches-search")) {
              gsap.to(elem, { display: "block", duration: 0, delay: 0.3 });
              gsap.to(elem, {
                autoAlpha: 1,
                y: "0",
                duration: 0.3,
                delay: delay,
              });

              delay += 0.05;
              resultsCount += 1;
            }
          }
        });

      if (resultsCount === 0) {
        $(this).hide();
      } else {
        $(this).show();
      }
    });
  }
  $(".people section.matches-category")
    .not("people section.matches-category:first:visible")
    .removeClass("first");
  $(
    ".people section.matches-category:visible:not(:visible ~ :visible)"
  ).addClass("first");
});

$(".people .filters input").on("change textInput input", function () {
  let val = $(this).val().toLowerCase();

  if (val != "") {
    $(".people section.matches-category").each(function () {
      let resultsCount = 0;
      $(this)
        .find(".profile")
        .each(function () {
          let name = $(this).data("fullname").toLowerCase();
          if (!name.includes(val)) {
            $(this).removeClass("matches-search");
            $(this).hide();
          } else {
            $(this).addClass("matches-search");
            if ($(this).hasClass("matches-filter")) {
              $(this).show();
              $(this).css("visibility", "visible");
              $(this).css("opacity", 1);
              resultsCount += 1;
            }
          }
        });
      if (resultsCount === 0) {
        $(this).hide();
      } else {
        $(this).show();
      }
    });
  } else {
    $(".people section.matches-category").show();
    $(".card.profile").addClass("matches-search");
    $(".card.profile").each(function () {
      if ($(this).hasClass("matches-filter")) {
        $(this).show();
        $(this).css("visibility", "visible");
        $(this).css("opacity", 1);
      }
    });
  }
  $(".people section.matches-category")
    .not("people section:first:visible")
    .removeClass("first");
  $(".people section:visible:not(:visible ~ :visible)").addClass("first");
});

$("#sort li").on("click", function () {
  let delay = 0.3;
  $("#sort li").not(this).removeClass("active");
  $(this).addClass("active");

  let sort = $(this).data("sort");
  if (sortBy != sort) {
    $(".matches-category .card.profile.matches-filter.matches-search").each(
      function () {
        let elem = $(this)[0];
        gsap.to(elem, { autoAlpha: 0, y: "3rem", duration: 0.3 });
        gsap.to(elem, { display: "none", duration: 0, delay: 0.3 });
      }
    );

    $(".card-listing").each(function () {
      let wrapper = $(this)[0];
      var cards = wrapper.querySelectorAll(
        ".matches-category .card.profile.matches-filter.matches-search"
      );
      cards = Array.from(cards);
      sortBy = sort;
      if (sort == "alpha") {
        cards.sort(function (a, b) {
          var surnameA = a.getAttribute("data-surname").toUpperCase();
          var surnameB = b.getAttribute("data-surname").toUpperCase();
          if (surnameA < surnameB) {
            return -1;
          }
          if (surnameA > surnameB) {
            return 1;
          }
          return 0;
        });
      } else {
        cards.sort(function (a, b) {
          var yearA = parseInt(a.getAttribute("data-year"));
          var yearB = parseInt(b.getAttribute("data-year"));
          return yearA - yearB;
        });
      }

      cards.forEach(function (card) {
        wrapper.appendChild(card);
      });
    });

    $(".matches-category .card.profile.matches-filter.matches-search").each(
      function () {
        let elem = $(this)[0];
        gsap.to(elem, { display: "block", duration: 0, delay: 0.3 });
        gsap.to(elem, { autoAlpha: 1, y: "0", duration: 0.3, delay: delay });
        delay += 0.05;
      }
    );
  }
});

$("#category-filter li a").on("click", function () {

  let href = $(this).attr("href");
  let id = $(this).attr("rel");

  if (typeof href === 'undefined') {

    $(".filter-wrap .label span").text("Filter by Expertise");
    $(".people .filters input").val("");
    $(".card.profile").addClass("matches-filter matches-search");

    if (id === "all") {
      $(".people section").fadeIn(150);
      $(".people section").removeClass("first");
      $(".people section").addClass("matches-category");
      $(".people main section:first-child").addClass("first");
      $("#category-filter li a").not(this).removeClass("active");
      $(this).addClass("active");

      $('#sort li[data-sort="year"]').addClass("active");
      $('#sort li[data-sort="alpha"]').removeClass("active");

      $(".card-listing").each(function () {
        let wrapper = $(this)[0];
        var cards = wrapper.querySelectorAll(
          ".matches-category .card.profile.matches-filter.matches-search"
        );
        cards = Array.from(cards);
        sortBy = sort;

        cards.sort(function (a, b) {
          var yearA = parseInt(a.getAttribute("data-year"));
          var yearB = parseInt(b.getAttribute("data-year"));
          return yearA - yearB;
        });

        cards.forEach(function (card) {
          wrapper.appendChild(card);
        });
      });

      gsap.to($(".card.profile"), {
        display: "block",
        duration: 0,
        delay: 0,
      });
      gsap.to($(".card.profile"), {
        autoAlpha: 1,
        y: "0",
        duration: 0.3,
        stagger: 0.05,
        delay: 0,
      });
    } else {
      let target = $(`#${id}`);

      $("#category-filter li a").not(this).removeClass("active");
      $(this).addClass("active");

      $(".people section").hide();
      $(".people section").removeClass("first");
      $(".people section").not(target).removeClass("matches-category");

      gsap.to($(".people section").not(target).find(".card.profile"), {
        autoAlpha: 0,
        y: "3rem",
        duration: 0.15,
      });
      gsap.to($(".people section").not(target).find(".card.profile"), {
        display: "none",
        duration: 0,
        delay: 0.15,
      });

      target.addClass("matches-category");
      target.addClass("first");
      target.fadeIn(150);
      gsap.to(target.find(".card.profile"), {
        display: "block",
        duration: 0,
        delay: 0.15,
      });
      gsap.to(target.find(".card.profile"), {
        autoAlpha: 1,
        y: "0",
        duration: 0.3,
        stagger: 0.1,
        delay: 0.15,
      });
    }
  }
});

$(".people .filters form").on("submit", function (e) {
  e.preventDefault();
}); 

$(window).on("load", function () {
  if ($("#category-filter li a.active").length) {
    $("#category-filter li a.active").trigger("click");
  }
});

// $("#category-filter.clerks-sub li a").on("click", function () {

//   let href = $(this).attr("href");
//   let id = $(this).attr("rel");

//   if (typeof href === 'undefined') {

//     $(".filter-wrap .label span").text("Filter by Department");
//     $(".people .filters input").val("");
//     $(".card.profile").addClass("matches-filter matches-search");

//     if (id === "all") {
//       $(".people section").fadeIn(150);
//       $(".people section").removeClass("first");
//       $(".people section").addClass("matches-category");
//       $(".people main section:first-child").addClass("first");
//       $("#category-filter li a").not(this).removeClass("active");
//       $(this).addClass("active");

//       $('#sort li[data-sort="year"]').addClass("active");
//       $('#sort li[data-sort="alpha"]').removeClass("active");

//       $(".card-listing").each(function () {
//         let wrapper = $(this)[0];
//         var cards = wrapper.querySelectorAll(
//           ".matches-category .card.profile.matches-filter.matches-search"
//         );
//         cards = Array.from(cards);
//         sortBy = sort;

//         cards.sort(function (a, b) {
//           var yearA = parseInt(a.getAttribute("data-year"));
//           var yearB = parseInt(b.getAttribute("data-year"));
//           return yearA - yearB;
//         });

//         cards.forEach(function (card) {
//           wrapper.appendChild(card);
//         });
//       });

//       gsap.to($(".card.profile"), {
//         display: "block",
//         duration: 0,
//         delay: 0,
//       });
//       gsap.to($(".card.profile"), {
//         autoAlpha: 1,
//         y: "0",
//         duration: 0.3,
//         stagger: 0.05,
//         delay: 0,
//       });
//     } else {
//       let target = $(`#${id}`);

//       $("#category-filter.clerks-sub li a").not(this).removeClass("active");
//       $(this).addClass("active");

//       $(".people section").hide();
//       $(".people section").removeClass("first");
//       $(".people section").not(target).removeClass("matches-category");

//       gsap.to($(".people section").not(target).find(".card.profile"), {
//         autoAlpha: 0,
//         y: "3rem",
//         duration: 0.15,
//       });
//       gsap.to($(".people section").not(target).find(".card.profile"), {
//         display: "none",
//         duration: 0,
//         delay: 0.15,
//       });

//       target.addClass("matches-category");
//       target.addClass("first");
//       target.fadeIn(150);
//       gsap.to(target.find(".card.profile"), {
//         display: "block",
//         duration: 0,
//         delay: 0.15,
//       });
//       gsap.to(target.find(".card.profile"), {
//         autoAlpha: 1,
//         y: "0",
//         duration: 0.3,
//         stagger: 0.1,
//         delay: 0.15,
//       });
//     }
//   }
// });


// Get the text of the active link
var activeExpertiseText = $('.filter-wrap #news-expertise-filter li a.active').text();

// Update the text of the span element by replacing only the "Filter by Expertise" part
var labelText = activeExpertiseText ? activeExpertiseText : 'Filter by Expertise';

// Update the text of the span element with the modified label text
$('#news-expertise-text').contents().first().replaceWith(labelText);







